import "swiper/css"
import { register } from "swiper/element/bundle"
import "./scss/global.scss"

// import { createApp } from "vue";
import { Flip, gsap, GSDevTools, ScrollSmoother, ScrollTrigger } from "@/composeables/gsap"
import debounce from "lodash.debounce"
import { createApp } from "troisjs"
window.gsap = gsap;
window.GSDevTools = GSDevTools;
window.ScrollTrigger = ScrollTrigger;
window.Flip = Flip;
// window.ScrollSmoother = ScrollSmoother;
// ScrollSmoother.create({
//     smooth: 1, // how long (in seconds) it takes to "catch up" to the native scroll position
//     effects: true, // looks for data-speed and data-lag attributes on elements
//     smoothTouch: 0.1, // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
// })

import { createPinia } from 'pinia'
// import { useBreakpoints } from "@vueuse/core";
// import { OnClickOutside } from "@vueuse/components";
// import { ExpandTransition, FadeTransition } from "@bam/transitions";

import * as ANIMATIONS from './animations'
import { init as fancyboxInit } from "./vanilla/fanybox"

let { height: bodyHeight, width: bodyWidth } = document.body.getBoundingClientRect().height;
const handleResize = debounce((entries, observer) => {
    const [ entry, ..._ ] = entries

    const newHeight = Math.round(entry.contentRect.height)
    const newWidth = Math.round(entry.contentRect.width)

    if (newHeight != bodyHeight || bodyWidth != newWidth) {
        bodyHeight = newHeight
        bodyWidth = newWidth
        setVh()
        ScrollTrigger.refresh();
    }
}, 30)
const resizeObserver = new ResizeObserver(handleResize);
resizeObserver.observe(document.body)

function setVh() {
    document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
}
setVh()
const handleWindowResize = debounce(() => { setVh() }, 50)
window.addEventListener('scroll', setVh, { passive: true })
// window.addEventListener('resize', (event) => { console.log(window.innerHeight); handleWindowResize(event)})
window.addEventListener('orientationchange', handleWindowResize)


Promise
    .all(
        Array.from(document.images)
            .filter(img => !img.complete)
            .map(img => new Promise(resolve => { img.onload = img.onerror = resolve; }))
    )
    .then(() => {
        window.setTimeout(() => { ScrollTrigger.refresh(); }, 0)
    });

// window.addEventListener("hashchange", () => {
//     setVh()
//     ScrollTrigger.refresh()
// })

// document.addEventListener("click", (event) => {
//     const { target } = event
//     const link = target.matches('a[href*="#"]')
//         ? target
//         : target.closest('a[href*="#"]')

//     if (!link) return;

//     const url = new URL(link.getAttribute("href"));
//     if (!(
//         url.protocol === location.protocol
//         && url.origin === location.origin
//         && url.pathname === location.pathname
//     )) {
//         return
//     }

//     event.preventDefault();

//     if (url.hash === "") {
//         history.pushState(null, null, url)
//         gsap.to(window, { scrollTo: { y: 0, autoKill: false } });
//         return
//     }

//     const href = url.hash.split('#').slice(1).join('#')
//     const hrefTarget = document.getElementById(href)
//     if (!hrefTarget) {
//         return
//     }

//     history.pushState(null, null, url)
//     gsap.to(window, { scrollTo: { y: hrefTarget, offsetY: 50, autoKill: false } });
// })

const app = createApp({
    data: () => {
        return {
            // globalSwiperModules: [Pagination, Parallax],
        };
    },
    update() {
        // console.log("vue update")
        ScrollTrigger.refresh()
    },
    mounted() {
        register();

        setTimeout(() => {


            // ScrollSmoother.create({
            //     smooth: 3, // how long (in seconds) it takes to "catch up" to the native scroll position
            //     effects: true, // looks for data-speed and data-lag attributes on elements
            //     smoothTouch: 0.1, // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
            // })
            // ScrollTrigger.config({
            //     ignoreMobileResize: true
            // })
            // ScrollTrigger.normalizeScroll(true)

            // ANIMATIONS.initZoomMedia()
            // ANIMATIONS.initElementMovement()

            // ANIMATIONS.initSectionStage();
            ANIMATIONS.initSectionPinnedMedia();
            // ANIMATIONS.initSectionText();
            ANIMATIONS.initSectionTextOnImage();
            ANIMATIONS.initSectionProductTeaser();
            ANIMATIONS.initSectionTextMedia();
            ANIMATIONS.initSectionMedia();

            // ANIMATIONS.initSectionForm();
            // ANIMATIONS.initFloatingActionBar();
            ScrollTrigger.refresh()
        }, 0)
    },
});

const pinia = createPinia()
app.use(pinia)

// app.config.compilerOptions.isCustomElement = (tag) => {
//     return tag.startsWith('swiper')
// }
// const bps = JSON.parse(
//     getComputedStyle(document.body).getPropertyValue("--bam-breakpoints")
// );
// const breakpoints = useBreakpoints(bps);
// app.config.globalProperties.$breakpoints = breakpoints;

const components = import.meta.glob("./components/**/*.vue", { eager: true });
Object.entries(components).forEach(([path, definition]) => {
    const componentName = path
        .split("/")
        .pop()
        .replace(/\.\w+$/, "");
    app.component(componentName, definition.default);
});

// app.component("expand-transition", ExpandTransition);
// app.component("fade-transition", FadeTransition);
// app.component("on-click-outside", OnClickOutside);

app.mount("#app");

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
// if (import.meta.hot) {
//     import.meta.hot.accept();
// }

fancyboxInit();
